/*** CALLED INTO PRODUCT PAGE FOR BUNDLE TOOLTIPS i  ***/
let isTooltipOpen = false;

const tooltips = Array.from(document.querySelectorAll(".jtooltip"));
const tooltipContainer = document.querySelector(".jtooltip-container-variation");
const closeButton = document.querySelector(".tooltip-close-btn");
const overlay = document.querySelector(".tooltip-overlay");

// MOBILE preset
const isMobile = window.matchMedia("(max-width: 768px)").matches;
const eventType = isMobile ? "click" : "mouseenter";


/*** ready showTooltip ***/
const showTooltip = (e) => {
  const rect = e.target.getBoundingClientRect();
  tooltipContainer.classList.add("jfade-in");
  overlay.classList.add("active");
  isTooltipOpen = true;
  

    if (isMobile) { //MOBILE
     const header = document.querySelector('header');
     const headerHeight = header ? header.offsetHeight : 0;
      tooltipContainer.style.left = `50%`;
      tooltipContainer.style.top = `${rect.top + window.scrollY + headerHeight - 175}px`;
      tooltipContainer.style.transform = "translateX(-50%)";
      } else { // DESKTOP
        tooltipContainer.style.top = `${rect.top + window.scrollY - 220}px`;
        tooltipContainer.style.left = `${rect.left + window.scrollX - tooltipContainer.offsetWidth}px`; 
    }
};


// Function to hide tooltip
const hideTooltip = () => {
  tooltipContainer.classList.remove("jfade-in");
  overlay.classList.remove("active");
  isTooltipOpen = false;
};

// Lsteners based on mobile/desktop screen size
tooltips.forEach((tooltip) => {
  tooltip.addEventListener(eventType, (e) => {
    e.stopPropagation(); 

    if (isMobile) {
      if (isTooltipOpen) {
        hideTooltip();
      } else {
        showTooltip(e);
      }
    } else {
      showTooltip(e); // Show on hover for desktop
    }
  });

  if (!isMobile) {
    tooltip.addEventListener("mouseout", (e) => {
      if (!tooltipContainer.contains(e.relatedTarget)) {
        hideTooltip();
      }
    });
  }
});

// DESKSTOP TOOLTIP CONTAINER LISTENERS
tooltips.forEach((tooltip) => {
  tooltip.addEventListener("mouseenter", showTooltip)
  tooltip.addEventListener("mouseout", (e) => {
    // Check if the mouse is moving into the tooltip container
    if (!tooltipContainer.contains(e.relatedTarget)) {
      hideTooltip()
    }
  })
})
// Add event listeners to the tooltip container to keep tooltip open and allow mouse click
tooltipContainer.addEventListener("mouseenter", () => {
  tooltipContainer.classList.add("jfade-in")
})
tooltipContainer.addEventListener("mouseleave", (e) => {
  // Check if the mouse is moving out of the tooltip container
  if (!tooltips.some((tooltip) => tooltip.contains(e.relatedTarget))) {
    hideTooltip()
  }
})


// Prevent tooltip from closing when clicking inside the container
tooltipContainer.addEventListener("click", (e) => {
  e.stopPropagation(); // Prevents closing when clicking inside the tooltip container
});


// Close tooltip when clicking the close button
closeButton.addEventListener("click", (e) => {
  e.stopPropagation(); // Prevents close button click from reopening the tooltip
  hideTooltip(); // Close tooltip when clicking the close button
});


// DATA SETS 09/24
document.querySelectorAll(".jtooltip").forEach((tooltip) => {
  tooltip.addEventListener("mouseenter", (e) => {
    // Get the dynamic data from the data-* attributes
    const title = tooltip.getAttribute("data-bundle-item-title");
    const html = tooltip.getAttribute("data-bundle-item-tooltip-text"); // rich text (HTML)
    const imgSrc = tooltip.getAttribute("data-bundle-item-img-src");
    const imgSrc2 = tooltip.getAttribute("data-bundle-item-tooltip-img2");

    // Update the tooltipContainer dynamically
    tooltipContainer.querySelector(".tooltip-container h3").textContent = title;
    tooltipContainer.querySelector(".tooltip-container span").innerHTML = html; // use innerHTML for rich text
    tooltipContainer.querySelector(".tooltip-container-img").src = imgSrc;
    //tooltipContainer.querySelector(".tooltip-container-img2").src = imgSrc2;

    // Check if imgSrc2 exists, and show or hide accentuate image
    const imgElement2 = tooltipContainer.querySelector(".tooltip-container-img2");
    if (imgSrc2) {
      imgElement2.src = imgSrc2;
      imgElement2.style.display = 'block';
    } else {
      imgElement2.style.display = 'none';
    }
    
  });
  
  tooltip.addEventListener("mouseout", () => {
    tooltipContainer.classList.remove("jfade-in");
  });
});

// Add event listener to close tooltip when clicking outside (on overlay)
overlay.addEventListener("click", () => {
  if (isTooltipOpen) {
    hideTooltip();
  }
});